import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "mySavedPaymentPage.m" */ "./Loadable"));
